import { graphql } from 'src/graphql';

export const MarkNotificationAsRead = graphql(`
  mutation MarkNotificationAsRead($_id: ID!) {
    markNotificationAsRead(_id: $_id) {
      _id
    }
  }
`);
